module.exports = __webpack_public_path__ + "static/media/clusters.3012d5bd.svg";